export default __webpack_public_path__ + "static/media/verified-animate.4a4e0ccb.svg";